import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

type LoginUserSettingPassWordChangeBodyProps = {
  updatePassword: (key: string, value: string) => void;
  hasCurrentPass: boolean;
}

const LoginUserSettingPassWordChangeBody: React.FC<LoginUserSettingPassWordChangeBodyProps> = (props) => {
  const { t } = useTranslation();
  const onChangeText = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    props.updatePassword(key, event.target.value);
  };

  // パスワードが無いとき(=初期状態)は現在のパスワードを入力できなくする
  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { m: 1, width: '25ch' },
      }}
      noValidate
      autoComplete="off"
    >
      <Grid container>
        <Grid item xs={12}>
          <TextField
            id="outlined-password-input"
            label={t('LoginUserSettingPage.現在のパスワード', '現在のパスワード')}
            type="password"
            autoComplete="current-password"
            onChange={onChangeText('nowPassword')}
            disabled={!props.hasCurrentPass}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-password-input"
            label={t('LoginUserSettingPage.新しいパスワード', '新しいパスワード')}
            type="password"
            autoComplete="current-password"
            onChange={onChangeText('newPassword')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-password-input"
            label={t('LoginUserSettingPage.パスワードの確認入力', 'パスワードの確認入力')}
            type="password"
            autoComplete="current-password"
            onChange={onChangeText('confirmationPassword')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginUserSettingPassWordChangeBody;
